export default __webpack_public_path__ + "static/media/calendar-edit-icon.35bfe538.svg";